import { Component, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, RouterOutlet } from "@angular/router";

import { FleetTrackerService } from "src/app/fleet-tracker.service";
declare const BrandVars;

@Component({
	selector: "app-fleet",
	templateUrl: "./fleet.component.html",
	styleUrls: ["./fleet.component.scss"],
	imports: [RouterOutlet]
})
export class FleetComponent {
	private route = inject(ActivatedRoute);
	private title = inject(Title);
	private fleettracker = inject(FleetTrackerService);

	private selectedFleet: number;

	constructor() {
		// A change in either the route parameter or the fleets collection must trigger a selection

		// Try to select fleet when route parameter is changed
		this.route.params.pipe(takeUntilDestroyed()).subscribe(params => {
			this.selectedFleet = Number(params["fleetid"]);
			this.fleettracker.SelectFleet(this.selectedFleet);
		});
		// Try to select fleet when fleet list is updated
		this.fleettracker.fleets.pipe(takeUntilDestroyed()).subscribe(() => {
			this.fleettracker.SelectFleet(this.selectedFleet);
		});
		// Change title on selected fleet change
		this.fleettracker.currentFleet.pipe(takeUntilDestroyed()).subscribe(newfleet => {
			if (newfleet) {
				this.title.setTitle(BrandVars.appName + " - " + newfleet.fleet_name);
			}
		});
	}
}
